import { StorageKeys } from "./localStorageKeys";

// Utility to generate a unique device/browser identifier using crypto.randomUUID
export const getDeviceId = (): string => {
  let id = localStorage.getItem(StorageKeys.deviceId);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(StorageKeys.deviceId, id);
  }
  return id;
};

